import React, { useEffect, useState } from 'react';
import { PreLoad } from '@teko/ecommerce';
import {
  checkExpiryDateTimestamp,
  convertObjectDiscoveryToQueryStringSearch,
} from 'helpers';
import { useTenantConfig, useServices } from 'contexts';
import { LIMIT_ITEM_PER_PAGE_PRODUCT_LIST } from 'constants/index';
import { useNewProductCard } from 'hooks';
import { Tab, TabItemProps } from '@teko/teko-ecommerce';
import { getTime } from 'helpers/datetime';

interface HotDealSectionProps {
  items: any[];
  blockId?: string;
}

export const HotDealSection: React.FunctionComponent<HotDealSectionProps> = ({
  items,
  blockId,
}: HotDealSectionProps) => {
  const { convertNewProductCard } = useNewProductCard();
  const [tabs, setTabs] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const { terminal } = useTenantConfig();
  const { discoveryService } = useServices();

  const getDataTabs = async () => {
    const actualItems = items.filter((el) =>
      checkExpiryDateTimestamp(el.startTime, el.endTime),
    );
    try {
      setLoading(true);
      const list = await Promise.all(
        actualItems.map((el) => {
          return discoveryService
            .search({
              ...el.paramsObject,
              terminalCode: terminal,
              itemPerPage: LIMIT_ITEM_PER_PAGE_PRODUCT_LIST,
              blockId,
            })
            .then((r) => ({
              ...el,
              products: r.result.products,
            }));
        }),
      );
      const newTabs = list
        .filter((el) => el.products && el.products.length)
        .map((el) => {
          return {
            title: el.label,
            description: el.subLabel,
            productsCarousel: {
              products: el.products.map((product) =>
                convertNewProductCard(product),
              ),
            },
            endAt: getTime(el.endTime),
            backgroundImage: el.imageUrl,
            link: `${convertObjectDiscoveryToQueryStringSearch(
              el.paramsObject,
            )}`,
          } as TabItemProps;
        });
      setTabs(newTabs);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDataTabs();
  }, [JSON.stringify(items), convertNewProductCard]);

  if (loading || tabs.length === 0) {
    return <PreLoad isLoading={loading} height={504.09} />;
  }
  return tabs.length ? <Tab tabs={tabs} /> : null;
};
